import { useState } from 'react';
import { SkupremeModal } from '../../components';
import { HoverBorderButton, MuteText, StyledButton, StyledInput } from '../../elements';
import { OrderService, ToastMessage } from '../../utility';

export function CancelOrderPopup({ open, onClose, refresh, orderId }) {
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState();

  const onConfirm = async () => {
    try {
      setLoading(true);
      const payload = {
        reason: reason || 'Warehouse Cancellation',
        action: 'cancel',
      };
      await OrderService.cancelOrder(orderId, payload);
      ToastMessage.success('Order Cancelled Successfully');
      onClose();
      refresh();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SkupremeModal
      size="mini"
      title="Confirm Cancelling Order"
      onClose={onClose}
      open={open}
    >
      <p className="m-0">Are you sure you want to cancel this order?</p>
      <div className="d-flex flex-column">
        <MuteText>Reason</MuteText>
        <StyledInput
          value={reason}
          onChange={e => setReason(e.target.value)}
          placeholder="Warehouse Cancellation"
        />
      </div>
      <div className="d-flex mt-4 justify-content-end">
        <HoverBorderButton disabled={loading} onClick={onClose}>
          Cancel
        </HoverBorderButton>
        <StyledButton loading={loading} onClick={() => onConfirm()} className="ml-2">
          Confirm
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
